//Styles / MUID
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

const userDark = createMuiTheme({
  palette: {
    type: "dark",
    contrastThreshold: 3
  }
});

export default userDark;



// WEBPACK FOOTER //
// ./src/styles/themes/userDark.js